export default "__VITE_ASSET__DefkphQ___"